module.exports = __webpack_public_path__ + "media/images/emblems/Anniviers-94bfc353407ef8ca782e118ddc2e38e1.png";